/**
 * A contextmenu eseményt figyeli és átpasszolja a preventert.
 * @param callback - A callback, amit meghív a contextmenu esetén.
 */
export default function preventContextMenu (callback: TEventCallback): void {
  window.addEventListener('contextmenu', callback)
}
